import { createApp } from 'vue'
import Timer from './components/Timer.vue'

document.querySelectorAll('.timer__wrapper__time').forEach(element => {
    const props = {
        time: JSON.parse(element.getAttribute('data-date-target')),
    };

    createApp(Timer, props).mount(element);
});
